import React from 'react'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import { Badge } from 'components/base'
import { DiscountIcon } from 'components/Utils/Icons'

export default function CouponLabel({
  coupon,
  tooltipContent = 'Displayed prices do not yet take coupons into account but be assured your invoice will',
}) {
  return (
    <TooltipOnHover id="coupon" tooltipContent={tooltipContent} placement="top">
      <Badge className="inline-block" paddingClass="padding-horizontal-smaller">
        <span className="font-size-normal">
          <DiscountIcon />
        </span>
        Yay! {coupon.name}
        <span role="img" aria-label="sparkle emoji">
          ✨
        </span>
      </Badge>
    </TooltipOnHover>
  )
}
